import React, { useCallback } from 'react';
import debounce from 'lodash/debounce';
import BaseSearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { usePositionsContext } from '@/creditflowresearch/application/PortfolioMonitor/PositionsContext';

const config = {
  name: 'searchPositions',
  placeholder: 'Filter by CUSIP, Bond or Issuer',
};

const SearchInput = (props) => {
  const {
    onSearch,
    search,
    onSetSearchUrlParam,
  } = usePositionsContext();
  const onChangeDebounced = useCallback(debounce(onSetSearchUrlParam, 500), []);

  const onChange = ({ target: { value } }) => {
    onSearch(value);
    onChangeDebounced(value);
  };

  return (
    <BaseSearchInput
      { ...props }
      { ...config }
      value={ search }
      onChange={ onChange }
      dataTest="formSearchInput"
    />
  );
};

export default SearchInput;
